function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRtnTitleLogoLetters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241.5 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0,84L21.45,0h35.79c16.79,0,27.46,10.56,27.46,24.36,0,12.96-9.19,23.76-23.29,28.32l9.19,31.32h-24.52l-7.48-29.04h-8.09l-7.48,29.04H0Zm35.06-46.8h13.48c7.35,0,12.63-5.4,12.63-11.64,0-4.56-3.19-7.56-7.48-7.56h-13.73s-4.9,19.2-4.9,19.2Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.47,84l16.55-64.8h-22.68L92.25,0h68.64l-4.9,19.2h-22.68l-16.55,64.8s-23.29,0-23.29,0Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.03,84L166.36,0h22.31l18.26,49.2L218.82,0h22.68l-21.33,84h-22.31l-18.39-49.2-11.65,49.2h-22.8,0Z",
    style: {
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtnTitleLogoLetters);
export default __webpack_public_path__ + "static/media/rtn-title-logo-letters.1f402da15bb269794a331bbd621c793b.svg";
export { ForwardRef as ReactComponent };